module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/imstillyourchild.com/node_modules/babel-runtime/core-js/object/set-prototype-of.js
// module id = 652
// module chunks = 184 185